import { render, staticRenderFns } from "./FacebookMapping.vue?vue&type=template&id=3be26108&scoped=true&lang=pug"
import script from "./FacebookMaping.js?vue&type=script&lang=js&external"
export * from "./FacebookMaping.js?vue&type=script&lang=js&external"
import style0 from "./FacebookMapping.vue?vue&type=style&index=0&id=3be26108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be26108",
  null
  
)

export default component.exports